<div class="busy-overlay-parent" [ngClass]="isLoading||!appState.isReady?'disabled':''">

    <div *ngIf="isLoading||!appState.isReady" class="font-weight-bold busy-overlay">
        <i class="fa fa-spinner fa-spin"></i>&nbsp;Loading...
    </div>

    <div *fesListView="let filteredVolunteers of volunteers">
        <div class="d-flex">
            <a href="javascript:false;" (click)="getVolunteers()"><i class="fas fa-sync"></i>&nbsp;Refresh</a>
        </div>
        <table class="table table-striped table-bordered table-sm">
            <thead>
            <tr>
                <th fesSortField="id">User ID</th>
                <th fesSortField="email">Email</th>
                <th fesSortField="name">Name</th>
                <th fesSortField="city">City</th>
                <th fesSortField="state">State</th>
                <th fesSortField="status">Status</th>
                <th fesSortField="debug" title="Enable debug messages from the volunteer's device">Debug</th>
                <th fesSortField="volunteerBuildingId">Building ID</th>
                <th fesSortField="morphology">Morphology</th>
                <th fesSortField="chestHeight">Chest Height (m)</th>
                <th fesSortField="modifiedByName">Modified By</th>
                <th fesSortField="modifiedAt">Modified At</th>
                <th style="text-align: center">
                    <button class="new-user-btn btn btn-secondary" (click)="editVolunteer(null)">
                        <i class="fa fa-plus-square"></i> new
                    </button>
                </th>
            </tr>
            </thead>
            <tbody>
            <tr>
                <td>
                    <input fesFilterField="id" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="email" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="name" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="city" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="state" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="status" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="debug" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="volunteerBuildingId" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="morphology" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="chestHeight" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="modifiedByName" class="small w-100"/>
                </td>
                <td>
                    <input fesFilterField="modifiedAt" [valueResolver]="modifiedAtResolver" class="small w-100"/>
                </td>

                <td></td>
            </tr>
            <tr *ngFor="let volunteer of filteredVolunteers">
                <td>{{volunteer.id}}</td>
                <td>{{volunteer.email}}</td>
                <td>{{volunteer.name}}</td>
                <td>{{volunteer.city}}</td>
                <td>{{volunteer.state}}</td>
                <td [ngClass]="'user-status-default user-status-'+volunteer.status">{{volunteer.status|titlecase}}</td>
                <td class="text-center" [ngClass]="volunteer.debug?'bg-warning':''">{{volunteer.debug}}</td>
                <td>{{volunteer.volunteerBuildingId}}</td>
                <td>{{volunteer.morphology}}</td>
                <td>{{volunteer.chestHeight}}</td>
                <td>{{volunteer.modifiedByName}}</td>
                <td>{{volunteer.modifiedAt | date:modifiedAtDateFormat}}</td>
                <td class="text-center align-middle text-nowrap">
                    <div class="flex flex-row">
                        <a class="mr-1" href="javascript:false;" (click)="editVolunteer(volunteer)">edit</a>
                        <div class="btn-group p-0 m-0" dropdown>
                            <a id="edit-options-btn" href="javascript:false;" behavior="button" dropdownToggle class="dropdown-toggle" aria-controls="dropdown-edit-options">
                                <span class="caret"></span>
                            </a>
                            <ul style="z-index:9999999;min-width:3rem;" id="dropdown-edit-options" *dropdownMenu class="p-2 dropdown-menu dropdown-menu-right" role="menu" aria-labelledby="edit-options-btn">
                                <li role="menuitem"><button class="btn btn-info mb-1" (click)="showAccessiblePoints(volunteer)">Accessible Points</button></li>
                                <li role="menuitem"><button class="btn btn-danger w-100" (click)="deleteVolunteer(volunteer)">Delete</button></li>
                            </ul>
                        </div>
                    </div>
                </td>
            </tr>
            </tbody>

        </table>
    </div>
</div>